function uppercaseFirstLetter(inputString) {
	if(typeof inputString !== 'string') {
		return inputString;
	}
	
	return inputString[ 0 ].toUpperCase() + inputString.substring(1);
}

export default uppercaseFirstLetter;
